import {useRefProvider} from "../hooks/useReducer";

export function SkipLink({ targetId }) {
    const { setRef } = useRefProvider();
    return (
        <a href={`#${targetId}`} className="skip-link" aria-label="Skip naar de hoofdinhoud" ref={setRef("skip-link")}>Skip naar de hoofdinhoud</a>
    )
}
export default SkipLink;
